var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$wf.isSmDown || _vm.shouldExpand
    ? _c(
        "app-mobile-full-screen-container",
        [
          _c(
            "w-toolbar",
            [
              _c("w-toolbar-text", { staticClass: "app-title" }, [
                _vm._v(" " + _vm._s(_vm.title) + " "),
              ]),
              _c("w-spacer"),
              !_vm.$wf.isSmDown
                ? _c(
                    "w-toolbar-item",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("common.maximize-window-toggle"),
                          expression: "$ct('common.maximize-window-toggle')",
                        },
                      ],
                      staticClass: "mr",
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleExpand()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "expand-alt" } })],
                    1
                  )
                : _vm._e(),
              _c(
                "w-toolbar-item",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.close"),
                      expression: "$ct('common.close')",
                    },
                  ],
                  attrs: { disabled: _vm.sending },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _vm.sending
            ? _c("w-progress-linear", {
                staticClass: "full",
                attrs: { color: "#1c86f0" },
              })
            : _vm._e(),
          _c(
            "w-scroll-view",
            {
              staticStyle: { "flex-grow": "1", height: "100%" },
              attrs: { tag: "w-card" },
            },
            [_vm._t("default")],
            2
          ),
        ],
        1
      )
    : _c(
        "w-scroll-view",
        {
          staticClass: "mail-client",
          attrs: {
            tag: "w-card",
            "tag-attributes": {
              "max-width": "1000",
              grow: true,
            },
          },
        },
        [
          _vm.$wf.isMdUp
            ? _c(
                "w-card-title",
                [
                  _vm._v(" " + _vm._s(_vm.title) + " "),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("common.maximize-window-toggle"),
                          expression: "$ct('common.maximize-window-toggle')",
                        },
                      ],
                      staticClass: "mr",
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleExpand()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "expand-alt", right: "" } })],
                    1
                  ),
                  _c(
                    "w-link",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("common.close"),
                          expression: "$ct('common.close')",
                        },
                      ],
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times", right: "" } })],
                    1
                  ),
                  _vm.sending
                    ? _c("w-progress-linear", {
                        staticClass: "full inTitle",
                        attrs: { color: "#1c86f0" },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._t("default"),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }